<template>
    <span>{{ currencySymbol }}</span>
</template>

<script>
export default {
    name: "CurrencySymbol",
    props: {
        currencyCode: {
            required: true
        },
    },
    computed: {
        currencySymbol() {
            try {
                switch (this.currencyCode) {
                    case "USD":
                        return "$"
                    case "EUR":
                        return "€"
                    case "SFR":
                    case "CHF":
                        return "Fr."
                    default:
                        return this.currencyCode
                }
            } catch (e) {
                return null
            }
        },
    }
}
</script>

<style scoped>

</style>
